import React, { FC, useState } from "react";
import Codemirror, {
  BasicSetupOptions,
  EditorView,
  Extension,
  ReactCodeMirrorRef,
} from "@uiw/react-codemirror";
import { githubLight } from "@uiw/codemirror-theme-github";
import { Button, Modal } from "antd";

import styles from "./index.less";

import { ReactComponent as FullscreenIcon } from "../../../../assets/fullscreen.svg";

type SupportedLanguage = "python";

export interface BasicEditorProps {
  ref?: React.RefObject<ReactCodeMirrorRef>;
  value?: string;
  onChange: (v: string) => void;
  placeholder?: string;
  language: SupportedLanguage;
  extensions?: Extension[];
  extendComponents?: React.ReactElement[];
  basicSetup?: BasicSetupOptions;
}

/**
 * 基本编辑器
 * @returns
 */
const BasicEditor: FC<BasicEditorProps> = ({
  ref,
  value,
  onChange,
  placeholder = "",
  extensions,
  extendComponents,
  basicSetup = {
    lineNumbers: true,
    closeBrackets: false,
  },
}) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <div className={styles["editor-container"]}>
      <Codemirror
        height="200px"
        className={styles.codemirror}
        ref={ref}
        value={value}
        theme={githubLight}
        onChange={onChange}
        basicSetup={basicSetup}
        extensions={[
          EditorView.lineWrapping, // 文本换行
          ...(extensions ?? []),
        ]}
        placeholder={placeholder}
      />
      <div className={styles["editor-actions"]}>
        <Button
          type="text"
          icon={<FullscreenIcon />}
          onClick={() => {
            setOpen(true);
          }}
        />
      </div>

      <Modal
        width={700}
        open={open}
        title="编辑器"
        onOk={() => {
          setOpen(false);
        }}
        footer={[]}
        classNames={{
          body: styles["editor-modal-body"],
          footer: styles["editor-modal-footer"],
        }}
        onCancel={() => setOpen(false)}
      >
        <Codemirror
          height="500px"
          className={styles.codemirror}
          ref={ref}
          value={value}
          theme={githubLight}
          onChange={onChange}
          basicSetup={basicSetup}
          extensions={[
            EditorView.lineWrapping, // 文本换行
            ...(extensions ?? []),
          ]}
          placeholder={placeholder}
        />
      </Modal>

      {/* 额外的组件 */}
      {extendComponents}
    </div>
  );
};

export default BasicEditor;
